import { orderBy, range } from 'lodash'

export const isClickedInside = (e: MouseEvent, element: Node | null) => {
    let node = e.target as Node | null
    while (node) {
        if (node === element) {
            return true
        }

        node = node.parentNode
    }

    return false
}

export const getPerceptualBrightness = (color: string) => {
    let r = Number.parseInt(color.substring(0, 2), 16)
    let g = Number.parseInt(color.substring(2, 4), 16)
    let b = Number.parseInt(color.substring(4, 6), 16)

    //return r + g + b
    return r * 2 + g * 3 + b
}

export const getBrightestColorForUuid = (id: string) => {
    id = id.replaceAll('-', '')

    let colors = orderBy(range(0, id.length - 6, 6).map(i => id.substring(i, i + 6)), c => getPerceptualBrightness(c), 'desc')
    return `#${colors[0]}`
}

export const isValidEmail = (email: string): boolean => {
    return !!email.match(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/gi);
}

export const pluralize = (count: number, word: string, two: string, five: string) => {
    const forms = [five, word, two, two, two, five, five, five, five, five];
    const mod100 = count % 100;

    if (mod100 <= 10 || mod100 >= 20)
        return forms[count % 10];
    else if (mod100 && mod100 < 20)
        return five;
}

const colors = ['#19a510', '#def70', '#8fd374', '#5f26f5', '#b927e0', '#a04571', '#e0ed5d', '#9c6577', '#eeb34a', '#5d97b8', '#fe943f', '#9eaea7', '#67458f', '#657dd8', '#679a6a', '#4426a6', '#cd885d', '#14518d', '#ab18bc', '#6a405f', '#678846', '#989c24', '#ee2793', '#bf7210', '#47ff2f', '#4e28c7', '#603242', '#d9cbdb', '#34a07a', '#1465bd', '#fa38d6', '#808c38', '#e45ff4', '#ae04ae', '#299bb6', '#fafd0f', '#9544c1', '#cc7fd8', '#2c5a64', '#4095c3', '#823283', '#824395', '#f8a592', '#1c12b4', '#2741d1', '#10c430', '#d521f4', '#3be40b', '#e83ffd', '#1e6ab1', '#b20b95', '#78880f', '#93b9fe', '#97f12e', '#cb810c', '#688cc2', '#886a8b', '#4874e9', '#75e1b', '#e4e94c', '#91a9f5', '#beb48d', '#6238be', '#a61d92', '#fd5933', '#c7ac9c', '#e88f8a', '#1d3014', '#49760b', '#725503', '#b61402', '#56ac52', '#c63f0f', '#2536ab', '#5dba65', '#3d3c20', '#760461', '#ad7527', '#6a75c6', '#5f7898', '#3d05d1', '#3cbc8', '#f9c0b4', '#3dd809', '#e82625', '#b6e174', '#352a6e', '#dbfbc9', '#cbf225', '#8af9b6', '#831d57', '#fd89a2', '#195298', '#745adc', '#2d34f2', '#941f8f']
//const colors = [
//    '#b44c4c',
//    '#741414',
//    '#acbcc4',
//    '#2c4d55',
//    '#c3a41a',
//    '#8eac50',
//    '#e49445',
//    '#ec5c8c',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//    '#',
//]

export const stringToColor = (str: string) => {
    let hash = 0
    let i

    /* eslint-disable no-bitwise */
    for (i = 0; i < str.length; i += 1) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash)
    }

    let color = '#'

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff
        color += `00${value.toString(16)}`.slice(-2)
    }
    /* eslint-enable no-bitwise */

    return color
}

export const currencies = [
    {
        iso: 'USD',
        sign: '$',
        name: 'Dollar USA',
    },
    {
        iso: 'EUR',
        sign: '€',
        name: 'Euro',
    },
    {
        iso: 'RUB',
        sign: '₽',
        name: 'Российский рубль',
    },
    //{
    //    iso: 'EUR',
    //    sign: '¥',
    //    name: 'Yen',
    //},
]
